import { httpClient, reportAxios } from "ultis/axios";

/** api getListExtension của report*/
const getListExtensionV1 = (params) => {
  return reportAxios.get("/api/v1/extensions", {
    params,
  });
};

const getListExtension = (params) => {
  return httpClient.get("/cloud-pbx/extension", {
    params,
  });
};

const getExtensionDetail = (id) => {
  return httpClient.get("/cloud-pbx/extension", {
    params: {
      filter: {
        where: { id },
      },
    },
  });
};

const getListExtensionContactCenters = (params) => {
  return reportAxios.get("/api/v1/provinces/report-extension", {
    params,
  });
};

const getListExtensionContactCentersUnit = (params) => {
  return reportAxios.get("/api/v1/provinces/unit-extension", {
    params,
  });
};

const createExtension = (payload) => {
  return httpClient.post("/cloud-pbx/extension", payload);
};

const editExtension = (id, payload) => {
  return httpClient.put(`/cloud-pbx/extension/${id}`, payload);
};

const deleteExtension = (id) => {
  return httpClient.post(`/cloud-pbx/extension/delete-extension/${id}`);
};

const getExtensionPassword = (id, ipAddress) => {
  return reportAxios.post(`/api/v1/extensions/${id}/password`, {
    ip: ipAddress,
  });
};

const getExtensionSecretKey = () => {
  return reportAxios.get(`/api/v1/extensions/info`, {
    disabledNotification: true,
  });
};

const getListProvinceTypeExtension = (params) => {
  return reportAxios.get(`/api/v1/provinces/type-extension`, { params });
};

export const ExtensionApi = {
  getListExtension,
  getListExtensionV1,
  getListExtensionContactCenters,
  createExtension,
  editExtension,
  deleteExtension,
  getExtensionDetail,
  getExtensionPassword,
  getExtensionSecretKey,
  getListProvinceTypeExtension,
  getListExtensionContactCentersUnit,
};
